(window.aeOnSectionReady || function (fn) { document.addEventListener('DOMContentLoaded', () => fn(document)); })((root) => {
  document.querySelectorAll('.ae-collection-main').forEach((section) => {
    if (section.dataset.aeBound === 'true') return;
    section.dataset.aeBound = 'true';
    const scroller = section.querySelector('.ae-collection-main__filters-scroller');
    const left = section.querySelector('.ae-collection-main__filters-scroll--left');
    const right = section.querySelector('.ae-collection-main__filters-scroll--right');
    const sortToggle = section.querySelector('.ae-collection-main__sort-label');
    const sort = section.querySelector('.ae-collection-main__sort');
    const searchInput = section.querySelector('.ae-collection-main__search-input');
    const searchForm = section.querySelector('.ae-collection-main__search');
    const grid = section.querySelector('.ae-collection-main__grid');
    const subToggle = section.querySelector('[id^="ae-collection-subscription-toggle-"]');

    if (scroller && left && right) {
      const amount = 220;
      left.addEventListener('click', () => scroller.scrollBy({ left: -amount, behavior: 'smooth' }));
      right.addEventListener('click', () => scroller.scrollBy({ left: amount, behavior: 'smooth' }));
    }

    if (sort && sortToggle) {
      sortToggle.addEventListener('click', () => {
        sort.classList.toggle('is-open');
      });

      if (!document.body.dataset.aeCollectionSortDocBound) {
        document.body.dataset.aeCollectionSortDocBound = 'true';
        document.addEventListener('click', (event) => {
          document.querySelectorAll('.ae-collection-main__sort.is-open').forEach((s) => {
            if (!s.contains(event.target)) s.classList.remove('is-open');
          });
        });
      }
    }

    section.querySelectorAll('input[type="checkbox"][data-ae-filter-url]').forEach((input) => {
      input.addEventListener('change', () => {
        const RETURN_KEY = 'ae:collection-return-url';
        const filterUrl = input.getAttribute('data-ae-filter-url');

        if (input.checked) {
          try { sessionStorage.setItem(RETURN_KEY, window.location.href); } catch (e) { /* private mode */ }
          if (filterUrl) window.location.href = filterUrl;
          return;
        }

        let stored = null;
        try {
          stored = sessionStorage.getItem(RETURN_KEY);
          if (stored) sessionStorage.removeItem(RETURN_KEY);
        } catch (e) { /* private mode */ }

        if (stored && stored !== window.location.href) {
          window.location.href = stored;
        } else if (window.history.length > 1 && document.referrer && document.referrer !== window.location.href) {
          window.history.back();
        } else if (filterUrl) {
          window.location.href = filterUrl;
        }
      });
    });

    section.querySelectorAll('[data-ae-collection-tooltip-trigger]').forEach((trigger) => {
      const tooltip = trigger.closest('[data-ae-collection-tooltip]');
      if (!tooltip) return;
      trigger.addEventListener('click', (event) => {
        event.preventDefault();
        const isOpen = tooltip.classList.toggle('is-open');
        trigger.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      });
    });
    if (!document.body.dataset.aeCollectionTooltipDoc) {
      document.body.dataset.aeCollectionTooltipDoc = 'true';
      document.addEventListener('click', (event) => {
        document.querySelectorAll('[data-ae-collection-tooltip].is-open').forEach((tt) => {
          if (!tt.contains(event.target)) {
            tt.classList.remove('is-open');
            const t = tt.querySelector('[data-ae-collection-tooltip-trigger]');
            if (t) t.setAttribute('aria-expanded', 'false');
          }
        });
      });
      document.addEventListener('keydown', (event) => {
        if (event.key !== 'Escape') return;
        document.querySelectorAll('[data-ae-collection-tooltip].is-open').forEach((tt) => {
          tt.classList.remove('is-open');
          const t = tt.querySelector('[data-ae-collection-tooltip-trigger]');
          if (t) {
            t.setAttribute('aria-expanded', 'false');
            t.focus();
          }
        });
      });
    }

    if (grid) {
      const subPriceEls = grid.querySelectorAll('.ae-collection-main__card-price--subscription');
      const regPriceEls = grid.querySelectorAll('.ae-collection-main__card-price--regular');
      const freqEls = grid.querySelectorAll('.ae-collection-main__card-frequency');

      const applyMode = () => {
        const on = subToggle ? subToggle.checked : false;
        grid.classList.toggle('is-subscription-mode', on);
        subPriceEls.forEach((el) => el.toggleAttribute('hidden', !on));
        regPriceEls.forEach((el) => el.toggleAttribute('hidden', on));
        freqEls.forEach((el) => el.toggleAttribute('hidden', !on));
      };

      if (subToggle) subToggle.addEventListener('change', applyMode);
      applyMode();
    }

    const sidebar = section.querySelector('[data-ae-collection-sidebar]');
    const sidebarTrigger = section.querySelector('[data-ae-sidebar-trigger]');
    const mobileMQL = window.matchMedia('(max-width: 989px)');
    const isMobileViewport = () => mobileMQL.matches;

    const openSidebar = () => {
      if (!sidebar) return;
      sidebar.classList.add('is-active');
      sidebar.setAttribute('aria-hidden', 'false');
      document.body.classList.add('ae-collection-sidebar-open');
      const closeBtn = sidebar.querySelector('[data-ae-sidebar-close]');
      if (closeBtn) requestAnimationFrame(() => closeBtn.focus({ preventScroll: true }));
    };

    const closeSidebar = () => {
      if (!sidebar) return;
      sidebar.classList.remove('is-active');
      sidebar.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('ae-collection-sidebar-open');
      if (sidebarTrigger) sidebarTrigger.focus({ preventScroll: true });
    };

    if (sidebarTrigger && sidebar) {
      sidebarTrigger.addEventListener('click', (event) => {
        if (isMobileViewport()) {
          event.preventDefault();
          if (sidebar.classList.contains('is-active')) {
            closeSidebar();
          } else {
            openSidebar();
          }
        }
      });
    }

    if (sidebar) {
      sidebar.querySelectorAll('[data-ae-sidebar-close]').forEach((btn) => {
        btn.addEventListener('click', closeSidebar);
      });
    }

    if (!document.body.dataset.aeCollectionSidebarDocBound) {
      document.body.dataset.aeCollectionSidebarDocBound = 'true';
      document.addEventListener('keydown', (event) => {
        if (event.key !== 'Escape') return;
        document.querySelectorAll('[data-ae-collection-sidebar].is-active').forEach((sb) => {
          sb.classList.remove('is-active');
          sb.setAttribute('aria-hidden', 'true');
          document.body.classList.remove('ae-collection-sidebar-open');
        });
      });

      document.addEventListener('click', (event) => {
        document.querySelectorAll('[data-ae-collection-sidebar].is-active').forEach((sb) => {
          if (sb.contains(event.target)) return;
          var host = sb.closest('.ae-collection-main') || document;
          var trig = host.querySelector('[data-ae-sidebar-trigger]');
          if (trig && trig.contains(event.target)) return;
          sb.classList.remove('is-active');
          sb.setAttribute('aria-hidden', 'true');
          document.body.classList.remove('ae-collection-sidebar-open');
        });
      });

      window.addEventListener('resize', () => {
        if (mobileMQL.matches) return;
        document.querySelectorAll('[data-ae-collection-sidebar].is-active').forEach((sb) => {
          sb.classList.remove('is-active');
          sb.setAttribute('aria-hidden', 'true');
          document.body.classList.remove('ae-collection-sidebar-open');
        });
      });
    }

    section.querySelectorAll('[data-ae-card-frequency-select]').forEach((select) => {
      if (select.dataset.aeBoundFreq === 'true') return;
      select.dataset.aeBoundFreq = 'true';
      const card = select.closest('.ae-collection-main__card');
      if (!card) return;
      const priceNow = card.querySelector('[data-ae-card-price-now]');
      const priceSave = card.querySelector('[data-ae-card-price-save]');
      const cartBtn = card.querySelector('[data-ae-supports-subscription]');
      const update = () => {
        const opt = select.options[select.selectedIndex];
        if (!opt) return;
        const price = opt.getAttribute('data-price');
        const pct = opt.getAttribute('data-savings-pct');
        if (priceNow && price) priceNow.textContent = price;
        if (priceSave) {
          const label = priceSave.getAttribute('data-save-label') || 'Save';
          priceSave.textContent = `${label} ${pct}%`;
        }
        if (cartBtn) cartBtn.setAttribute('data-default-selling-plan', opt.value);
      };
      select.addEventListener('change', update);
      update();
    });

    section.querySelectorAll('[data-ae-supports-subscription]').forEach((btn) => {
      if (btn.dataset.aeBound === 'true' || btn.disabled) return;
      btn.dataset.aeBound = 'true';
      btn.addEventListener('click', () => {
        const variantId = btn.getAttribute('data-variant-id');
        const inSubMode = grid && grid.classList.contains('is-subscription-mode');
        const opts = { button: btn };
        if (inSubMode) {
          const card = btn.closest('.ae-collection-main__card');
          const select = card && card.querySelector('[data-ae-card-frequency-select]');
          const planId = (select && select.value) || btn.getAttribute('data-default-selling-plan');
          if (planId) opts.sellingPlan = planId;
        }
        if (typeof window.ancientAddToCart === 'function') {
          window.ancientAddToCart(variantId, opts);
        }
      });
    });

    if (typeof window.bindAncientAddToCartButtons === 'function') {
      window.bindAncientAddToCartButtons(section);
    }
  });

  const overlay = document.querySelector('[data-js-sidebar-overlay]');
  const drawer = document.getElementById('site-cart-sidebar');
  if (overlay && drawer && typeof drawer.hide === 'function' && !overlay.dataset.bound) {
    overlay.dataset.bound = 'true';
    overlay.addEventListener('click', () => drawer.hide());
  }

  if (typeof window.bindAncientAddToCartButtons === 'function') {
    window.bindAncientAddToCartButtons(document);
  }

  if (window.refreshCart) {
    window.refreshCart();
  }

  let lastCart = null;

  const syncSteppers = (cart) => {
    if (!cart || !Array.isArray(cart.items)) return;
    document.querySelectorAll('.ae-collection-main__card-add-wrapper[data-variant-id]').forEach((wrapper) => {
      const variantId = parseInt(wrapper.dataset.variantId, 10);
      const item = cart.items.find((i) => Number(i.variant_id) === variantId);
      const qty = item ? item.quantity : 0;
      const addBtn = wrapper.querySelector('[data-ae-add]');
      const stepper = wrapper.querySelector('[data-ae-stepper]');
      const count = wrapper.querySelector('[data-ae-stepper-count]');
      if (qty > 0) {
        if (addBtn) addBtn.hidden = true;
        if (stepper) stepper.hidden = false;
        if (count) count.textContent = qty;
      } else {
        if (addBtn) addBtn.hidden = false;
        if (stepper) stepper.hidden = true;
      }
    });
  };

  const fetchCartAndSync = async () => {
    try {
      const r = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
      lastCart = await r.json();
      syncSteppers(lastCart);
    } catch (e) { /* swallow */ }
  };

  const changeQty = async (variantId, newQty) => {
    try {
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: Math.max(0, newQty) })
      });
      if (typeof window.refreshCart === 'function') {
        await window.refreshCart();
      } else {
        await fetchCartAndSync();
      }
    } catch (e) { /* swallow */ }
  };

  document.querySelectorAll('.ae-collection-main').forEach((section) => {
    section.addEventListener('click', async (event) => {
      const plus = event.target.closest('[data-ae-stepper-plus]');
      const minus = event.target.closest('[data-ae-stepper-minus]');
      if (!plus && !minus) return;
      event.preventDefault();
      const wrapper = event.target.closest('.ae-collection-main__card-add-wrapper');
      if (!wrapper) return;
      const variantId = parseInt(wrapper.dataset.variantId, 10);
      const item = (lastCart && lastCart.items || []).find((i) => Number(i.variant_id) === variantId);
      const cur = item ? item.quantity : 0;
      const next = cur + (plus ? 1 : -1);
      const btn = event.target.closest('button');
      if (btn) btn.disabled = true;
      await changeQty(variantId, next);
      if (btn) btn.disabled = false;
    });
  });

  document.addEventListener('cart-updated', fetchCartAndSync);

  fetchCartAndSync();
});
